<template>
    <div id="contact-modal" v-show="show">
        <div :class="'modal fade ' + showModal" tabindex="-1" aria-modal="true" role="dialog" style="display: block;">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content" v-click-outside="close" style="overflow:hidden;">
                    <div class="modal-header" v-if="title.length">
                        <h5 class="modal-title">
                            {{ title }}
                        </h5>
                    </div>
                    <div class="modal-body">
                        <slot></slot>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="close">Sluit</button>
                    </div>
                </div>
            </div>
        </div>
        <div :class="'modal-backdrop fade ' + showModal" v-show="show"></div>
    </div>
</template>

<script>

import vClickOutside from "click-outside-vue3";
import axios from "axios";

export default {
    components: {},

    props: {
        title: {default: ''},
        show: {default: true},
    },

    mixins: [],

    data: function () {
        return {

        };
    },

    directives: {
        clickOutside: vClickOutside.directive
    },

    computed: {
        showModal() {
            return this.show ? 'show' : '';
        }
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        close() {
            this.$emit('closed');
        }
    },

    watch: {
        //
    }
};
</script>
<style lang="scss" scoped>
    .modal-footer {
        padding: inherit;
    }
</style>
